// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './theme/theme';

// Import your components
import Navbar from './components/Navbar';
import Footer from 'components/Footer';
import HomePage from './pages/HomePage';
import AboutUsPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import InteriorDesignPage from './pages/services/InteriorDesignPage';
import VisualizationPage from './pages/services/VisualizationPage';
import CommercialDesignPage from './pages/services/CommercialDesignPage';
import ResidentialDesignPage from './pages/services/ResidentialDesignPage';
import SpacePlanningPage from './pages/services/SpacePlanningPage';
import PortfolioPage from './pages/portfolio/PortfolioPage';
import ResidentialPortfolio from './pages/portfolio/ResidentialPortfolio';
import CommercialPortfolio from './pages/portfolio/CommercialPortfolio';
import HospitalityPortfolio from './pages/portfolio/HospitalityPortfolio';
import ContactPage from './pages/ContactPage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="App">
          <Navbar />
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            
            {/* Services */}
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/interior-design" element={<InteriorDesignPage />} />
            <Route path="/services/3d-visualization" element={<VisualizationPage />} />
            <Route path="/services/commercial-design" element={<CommercialDesignPage />} />
            <Route path="/services/residential-design" element={<ResidentialDesignPage />} />
            <Route path="/services/space-planning" element={<SpacePlanningPage />} />
            
            {/* Portfolio */}
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/portfolio/residential" element={<ResidentialPortfolio />} />
            <Route path="/portfolio/commercial" element={<CommercialPortfolio />} />
            <Route path="/portfolio/hospitality" element={<HospitalityPortfolio />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;